import { useMemo } from 'react';
import { TableFilters, TableState } from '@optimus-web/core';
import { ProductChecklistResult, useRepositoryQuery } from '@mews-commander/data-access';
import { useDateRangeBySelectedFilterDate } from '../utils/useDateRangeBySelectedFilterDate';
import { FilterValueKey, ProductCheckListFilterValues } from '../components/panels/ProductCheckListFilterFields/types';
import {
    getProductFiltersQueryParam,
    getReservationFiltersQueryParam,
    getOrderingQueryParams,
} from '../utils/productChecklistQueryParams';

export const useProductCheckListQuery = <RowType, Result>(
    tableState: TableState<RowType, TableFilters<RowType>>,
    filters: ProductCheckListFilterValues,
    select?: (result: ProductChecklistResult) => Result
) => {
    const { startLocal, endLocal } = useDateRangeBySelectedFilterDate(filters[FilterValueKey.date]);

    const productChecklistFilters = useMemo(
        () => ({
            ...getOrderingQueryParams(tableState),
            productFilters: getProductFiltersQueryParam(filters),
            reservationFilters: getReservationFiltersQueryParam(filters),
        }),
        [tableState, filters]
    );

    return useRepositoryQuery(
        'productChecklist',
        'get',
        {
            reportIntervalLocal: {
                start: startLocal.value,
                end: endLocal.value,
            },
            count: tableState.pagination.pageSize,
            startIndex: tableState.pagination.pageIndex * tableState.pagination.pageSize,
            searchToken: tableState.globalFilters.search,
            productChecklistFilters,
        },
        {
            select,
        }
    );
};
